export default "__VITE_ASSET__DH1eh1Uk__"